import { CookieConsentService } from '@/app/core/services/cookie-consent.service';
import { Component, OnInit, inject } from '@angular/core';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'dk-cookie-consent',
  imports: [SharedModule],
  templateUrl: './dk-cookie-consent.component.html',
  styleUrls: ['./dk-cookie-consent.component.less'],
})
export class DkCookieConsentComponent implements OnInit {
  private readonly cookieService = inject(CookieConsentService);

  // Use signals from the service
  readonly isBannerVisible = this.cookieService.isBannerVisible;

  ngOnInit(): void {
    // Banner visibility is now managed by the service
    // No need to manually check here
  }

  accept(): void {
    this.cookieService.setConsent({
      essentials: true,
      analytics: true,
    });
  }

  decline(): void {
    this.cookieService.setConsent({
      essentials: true,
      analytics: false,
    });
  }

  acceptEssentialsOnly(): void {
    this.cookieService.setConsent({
      essentials: true,
      analytics: false,
    });
  }

  acceptAll(): void {
    this.cookieService.setConsent({
      essentials: true,
      analytics: true,
    });
  }
}
